import styled from 'foundations-theming-specialty/utils';
import { BREAKPOINT_MEDIUM } from 'global-search-shared';
export const StyledSearchInput = styled.input.withConfig({
  displayName: "StyledSearchInput",
  componentId: "sc-1fd7urr-0"
})(["display:block !important;flex-grow:1;outline:none;width:100%;height:100%;font:", " !important;text-indent:", ";transform:translateZ(0);background:none !important;will-change:color,padding;color:var(--search-input-color) !important;padding:", ";padding-right:", ";transition:", ";@media (max-width:", "px){padding-left:30px !important;}&::placeholder{color:var(--search-input-color) !important;}"], ({
  theme
}) => `${theme.typography['body-100'].fontWeight} ${theme.typography['body-100'].fontSize}/${theme.typography['body-100'].lineHeight} ${theme.typography['body-100'].fontFamily}`, ({
  isTrellis
}) => isTrellis ? '0' : '8px', ({
  isOpen,
  isTrellis,
  theme
}) => {
  if (isTrellis) {
    return isOpen ? `${theme.space['200']} 36px ${theme.space['200']} ${theme.space['400']} !important` : `0 0 0 ${theme.space['400']} !important`;
  }
  return isOpen ? `${theme.space['200']} 36px ${theme.space['200']} 42px !important` : `0 0 0 40px !important`;
}, ({
  hasValue
}) => hasValue && '36px !important', ({
  isOpen
}) => isOpen ? `color .2s ease,
    padding .2s ease !important;` : '', BREAKPOINT_MEDIUM - 1);